<form [formGroup]="form" (ngSubmit)="onSubmit()" autocomplete="off">

    <nav class="toolbar navbar navbar-light">
        <div class="form-inline">
            <button class="btnback btn btn-outline-success" type="button" (click)="onBack()"><i class="fa fa-chevron-left"></i></button>
            <button *ngIf="!visibilitySpinner" [disabled]="!habilitarGuardar || formInvalid" type="button" (click)="onSubmit()" class="btn btn-outline-success "><i class="fa fa-save"></i> Guardar</button>
            <button *ngIf="visibilitySpinner" [disabled]="true" class="btn btn-outline-success">
                <p-progressSpinner class="spinnerExcel"></p-progressSpinner>
                Guardando
            </button>
        </div>
    </nav>

    <div class="animated fadeIn container-fluid">
        <h4 style="display:inline">{{editTitle}} Documento {{CodigoSolicitud}}</h4>
        <h5 style="display:inline; margin-left: 8px">
            <span>
                <!--***ICONOS***-->
                <img class="estado-icono-big" container="body" src="{{ null | IconoEstadoSolicitudEx}}" ngbTooltip="{{tituloTipoSolicitud}}" />
                <!--<img class="asignada-icono" src="{{ null | IconoSolicitudAsignada}}" />-->
                <label class="codigo-icono-big" container="body" ngbTooltip="{{tituloTipoSolicitud}}">{{CodigoTipoSolicitud}}</label>
                <img class="estado-icono-big" container="body" src="{{IdEstadoSolicitudEx | IconoEstadoSolicitudEx}}" ngbTooltip="{{EstadoSolicitudExDescripcion}}" />
                <img *ngIf="IdSubTipoSolicitudEx === tercerPaisConAtestFito || IdSubTipoSolicitudEx === reExpConAtestFito || IdSubTipoSolicitudEx === canariasConAtestFito"
                     class="estado-icono-big" src="{{alegacionEx.IdSubTipoSolicitudEx | IconoTwTcSubTipoSolicitudEx}}" container="body" ngbTooltip="{{alegacionEx.IdSubTipoSolicitudExDescripcion}}" />
                <img class="estado-icono-big" container="body" src="{{alegacionEx.IdEstadoCertificadoFitoEx | IconoEstadoCertificadoFitoEx}}" ngbTooltip="{{alegacionEx.IdEstadoCertificadoFitoExDescripcion}}" />
                <img *ngIf="IdResultadoEnvioMuestrasLaboratorioEx" class="estado-icono-big" container="body" src="{{IdResultadoEnvioMuestrasLaboratorioEx | IconoResultadoEnvioMuestraLaboratorio}}" ngbTooltip="{{DescripcionIdResultadoEnvioMuestrasLaboratorioEx}}" />
                <img *ngIf="esClonada" class="estado-icono-big" container="body" src="{{ null | IconoEstadoSolicitudEx}}" ngbTooltip="Clonada" />
                <i *ngIf="esClonada" class="fa fa-clone clone-icono-big" ngbTooltip="Clonada"></i>
            </span>
        </h5>

        <div class="row">
            <div class="col-md-12">

                <ng-container *ngIf="IdSolicitudEx">
                    <app-alertarechazo [id]="IdSolicitudEx" [esExport]="true"></app-alertarechazo>
                </ng-container>

                <div class="card card-accent-success animated fadeIn">

                    <div class="card-header">
                    </div>

                    <div class="card-body-detalle">


                        <div class="row">

                            <div class="form-group col-md-9">
                                <label class="col-form-label required-field" for="intEstado">Documento</label>
                                <app-document-uploader [parentForm]="form" [parentSubmitted]="submitted" [readOnly]="!habilitarGuardar" [uploadedFile]="uploadedFile" [megaSizeLimit]="megaSizeLimit" (fileUploaded)="onFileUploaded($event)"
                                                       (fileDeleted)="onFileDeleted($event)"></app-document-uploader>
                            </div>
                        </div>                        

                    </div>
                </div>
            </div>
        </div>
    </div>

</form>
